import type { Cage, Transit } from '../index.h'

import { createEvent, sample } from 'effector'
import { model as router } from '~/core/router'
import { profilesModel } from '~/entities/profiles'
import { keys } from '~/shared/jail'

/*
 * ### App cage ###
 */

const init = createEvent<Transit>('init')

const chooseProfileApp = createEvent('chooseProfileApp')

export const app = {
  name: 'app',
  key: keys.app,
  init,
  in: [],
  out: {
    chooseProfileApp,
  },
} satisfies Cage

/*
 * cage logic
 */

sample({
  clock: profilesModel.updateProfileActiveStateFx.done,
  target: chooseProfileApp,
})

sample({
  clock: profilesModel.updateProfileActiveStateFx.done,
  source: router.$location,
  filter: (location) => !location?.pathname || !/~/.test(location.pathname),
  fn: () => '/',
  target: router.navigateReplace,
})
